import { render, staticRenderFns } from "./detalhes-do-produto.html?vue&type=template&id=541eb728&scoped=true&"
import script from "./detalhes-do-produto.vue?vue&type=script&lang=js&"
export * from "./detalhes-do-produto.vue?vue&type=script&lang=js&"
import style0 from "./detalhes-do-produto.less?vue&type=style&index=0&id=541eb728&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541eb728",
  null
  
)

export default component.exports